require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-i-ka-3-p.json") })
        }
      }, "path---photos-professional-i-ka-3-p");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-i-ka-3-p!./.cache/json/photos-professional-i-ka-3-p.json
// module id = 774
// module chunks = 231608221292675